export default __webpack_public_path__ + "static/media/Lateral_Right_Female_.164b531a.png";